import cloneDeep from 'lodash/cloneDeep';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';

export default function transformer(serverTableData) {
  const data = cloneDeep(serverTableData);
  if (data.orderBy === 'enseigne') {
    data.orderBy = 'enseigneNomCommercial';
  }
  if (data.orderBy === 'campagne') {
    data.orderBy = 'campagneLibelle';
  }
  if (data.orderBy === 'typeMateriel') {
    data.orderBy = 'materielTypeLibelle';
  }
  return generalTransformer(data);
}
